import { combineReducers } from 'redux'
import { REGISTER_CHECK_ERROR, REGISTER_CHECK_LOADING, REGISTER_CHECK_SUCCESS, REGISTER_ERROR, REGISTER_LOADING, REGISTER_SUCCESS } from './constant'

const registerCheckError = (state = false, action) => {
  switch (action.type) {
    case REGISTER_CHECK_ERROR:
      return action.registerCheckError
    default:
      return state
  }
}

const registerCheckLoading = (state = false, action) => {
  switch (action.type) {
    case REGISTER_CHECK_LOADING:
      return action.registerCheckLoading
    default:
      return state
  }
}

const registerCheckSuccess = (state = false, action) => {
  switch (action.type) {
    case REGISTER_CHECK_SUCCESS:
      return action.registerCheckSuccess
    default:
      return state
  }
}

const registerCheck = (state = [], action) => {
  switch (action.type) {
    case REGISTER_CHECK_SUCCESS:
      return action.registerCheck
    default:
      return state
  }
}

const registerError = (state = false, action) => {
  switch (action.type) {
    case REGISTER_ERROR:
      return action.registerError
    default:
      return state
  }
}

const registerLoading = (state = false, action) => {
  switch (action.type) {
    case REGISTER_LOADING:
      return action.registerLoading
    default:
      return state
  }
}

const registerSuccess = (state = false, action) => {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return action.registerSuccess
    default:
      return state
  }
}

const registerReducer = combineReducers({
  registerCheckError,
  registerCheckLoading,
  registerCheckSuccess,
  registerCheck,

  registerError,
  registerLoading,
  registerSuccess
})

export default registerReducer
